import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPower = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 10,
		stroke: "currentColor",
		strokeWidth: 2,
		fill: "none",
		strokeDasharray: "42.33 10",
		strokeDashoffset: 0
	}), /* @__PURE__ */ _jsx("line", {
		x1: 12,
		y1: 0,
		x2: 12,
		y2: 10,
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})]
});
export default SvgPower;
